import { Skeleton } from "primereact/skeleton";
import React from "react";
import PurchaseOrderMobileItem from "./PurchaseOrderMobileItem";


const PurchaseOrderMobileSkeleton = () =>{
    return(
        <div className="flex flex-column px-3 py-2">
            <div className="flex flex-column mb-2">
                <Skeleton className="flex align-self-start mb-3" width="8rem" height="0.8rem"></Skeleton>
                <div className="flex align-self-center mb-2">
                    <Skeleton width="20rem" height="2.5rem"></Skeleton>
                </div>
            </div>
            <PurchaseOrderMobileItem />
            <PurchaseOrderMobileItem />
            <PurchaseOrderMobileItem />
            <PurchaseOrderMobileItem />
            <PurchaseOrderMobileItem />
            <PurchaseOrderMobileItem />
            <PurchaseOrderMobileItem />
        </div>
    )
}

export default PurchaseOrderMobileSkeleton;